// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  siteUrl: 'http://localhost:8100/',
  firebase: {
    projectId: 'sharesquare-59cf8',
    appId: '1:1077799327618:web:4fbf8c7e501db13f89219b',
    databaseURL: 'https://sharesquare-59cf8-default-rtdb.firebaseio.com',
    storageBucket: 'sharesquare-59cf8.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyAx_s1g8Bk0yv45uTWhxrGTbOrOSjjNPSg',
    authDomain: 'sharesquare-59cf8.firebaseapp.com',
    messagingSenderId: '1077799327618',
    measurementId: 'G-6ZZE9NY1JN',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
